const BE = {
  ibanLength: 16,
};
export { BE };
